import React from "react";
import AllMotorCyles from "../../assets/images/Insurance Companies/All-Motors.png";
import Aetna from "../../assets/images/Insurance Companies/aetna-international-logo.png";
import AvMed from "../../assets/images/Insurance Companies/AvMed.png";
import BlueShield from "../../assets/images/Insurance Companies/Blue-Cross-Blue-Shield-Logo.png";
import Citrus from "../../assets/images/Insurance Companies/Citrus County Rual Health.png";
import Freedom from "../../assets/images/Insurance Companies/FH_logo.gif";
import Humana from "../../assets/images/Insurance Companies/humana.png";
import Medicare from "../../assets/images/Insurance Companies/medicare.svg";
import Optimum from "../../assets/images/Insurance Companies/optimum.png";
import OptimumServe from "../../assets/images/Insurance Companies/optum-serve.svg";
import Tricare from "../../assets/images/Insurance Companies/TRICARElogo.svg";
import Ultimate from "../../assets/images/Insurance Companies/Ultimate.svg";
import United from "../../assets/images/Insurance Companies/united-healthcare-logo.png";
import UnitedCommunity from "../../assets/images/Insurance Companies/uhccp-logo.png";
import Veterans from "../../assets/images/Insurance Companies/Veterans.png";
import Workers from "../../assets/images/Insurance Companies/Worker’s Compensation.png";

const insuranceOptions = [
  { label: "Aetna", img: Aetna },
  { label: "AvMed", img: AvMed },
  { label: "All Motor Vehicle Claims", img: AllMotorCyles },
  { label: "Blue Cross Blue Shield ", img: BlueShield },
  //   { label: "Blue Cross Out of State Plans ", img: BlueShield },
  { label: "Citrus County Rual Health", img: Citrus },
  { label: "Federal Blue Cross", img: BlueShield },
  { label: "Freedom Health", img: Freedom },
  { label: "Humana", img: Humana },
  { label: "Medicare", img: Medicare },
  { label: "Optimum Healthcare", img: Optimum },
  { label: "Optum Serve", img: OptimumServe },
  { label: "Tricare ", img: Tricare },
  //   { label: "Tricare ", img: Tricare },
  { label: "Ultimate", img: Ultimate },
  { label: "United Healthcare ", img: United },
  { label: "United Healthcare Community", img: UnitedCommunity },
  //   { label: "United Healthcare Medicare", img: United },
  { label: "Veterans Choice Program", img: Veterans },
  { label: "Worker’s Compensation", img: Workers },
];

export default function Insurance() {
  return (
    <div className="w-[80%] mx-auto xl:py-[5rem] py-[6rem] xl:px-16 2xl:px-0">
      <div>
        <h2 className="2xl:text-6xl leading-normal xl:text-[3.75rem] pb-20 text-5xl text-center font-bold mb-6 font-robout text-[#d78558] capitalize">
          Insurance information
        </h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-5 gap-0">
        {insuranceOptions.map((option, index) => (
          <div
            key={index}
            className="flex flex-col items-center justify-between p-8  text-white h-auto"
          >
            {/* Logo */}
            <div className="flex flex-col items-center ">
              <img
                src={option.img}
                alt={option.label}
                className="w-full h-40 object-contain bg-[#FEECE2] rounded-lg p-4"
              />
              <p className="text-center text-lg font-medium leading-snug mt-4 font-robout">
                {option.label}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
